// @ts-nocheck
import React, { lazy } from 'react';
import { Dialog, DialogSuspense } from '@/components';
import withDialogRedux from '@/components/DialogReduxConnect';
import { compose } from '@/utils';

const LogoLibraryFormDialogContent = lazy(() => import('./LogoLibraryFormDialogContent'));

function LogoLibraryFormDialog({
  dialogName,
  payload = { action: '', logo: null },
  isOpen,
}) {
  return (
    <Dialog
      name={dialogName}
      title={payload.action === 'edit' ? 'Edit Logo' : 'Logo Library'}
      isOpen={isOpen}
      autoFocus
      canEscapeKeyClose
      style={{ width: '860px' }}
    >
      <DialogSuspense>
        <LogoLibraryFormDialogContent
          dialogName={dialogName}
          action={payload.action}
          logo={payload.logo}
        />
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(LogoLibraryFormDialog);
